// Página de informação do produto.
// O produto é identificado pelo parâmetro ?prd=<id> da URL (?sku=<sku> é opcional e define a cor exibida).
const API_URL = 'https://api.dorel.com.br/v1/catalog/product_assistances';
const REGISTRY_PATH = '/registro';
const YOUTUBE_OEMBED = 'https://www.youtube.com/oembed';

const urlParams = new URLSearchParams(window.location.search);
const prd = urlParams.get('prd');
const sku = urlParams.get('sku');

const productInfo = document.getElementById('productInfo');
const infoLinks = document.getElementById('info-links');
const categoryName = document.querySelector('.category-name');
const productTitle = document.querySelector('#productInfo h1');
const productColorName = document.querySelector('.product-color');
const manualLink = document.getElementById('manual-link');
const manualList = document.getElementById('manual-list');
const videoContainer = document.querySelector('.video-container');
const registryLinks = document.querySelectorAll('[data-registry-link]');

async function getData(apiUrl) {
  const response = await fetch(apiUrl);
  if (!response.ok) {
    throw new Error(`Não foi possível carregar o catálogo (${response.status})`);
  }
  return response.json();
}

async function inicializar(apiUrl) {
  setRegistryLink(prd);

  if (!prd && !sku) return;

  try {
    const data = await getData(apiUrl);
    const product = findProduct(data, prd, sku);
    if (product) {
      await setProductInfo(product);
    }
  } catch (error) {
    console.error('Erro ao carregar os dados do produto:', error);
  }
}

// Produto pelo parâmetro prd (id); sem resultado, tenta pelo sku de um dos itens
function findProduct(data, id, cod_sku) {
  if (!Array.isArray(data)) return null;

  if (id) {
    const byId = data.find((pd) => pd.id === id);
    if (byId) return byId;
  }
  if (cod_sku) {
    return data.find((pd) => (pd.items || []).some((item) => item.sku === cod_sku)) || null;
  }
  return null;
}

// Item (cor) do produto: o do sku informado ou, na falta dele, o primeiro com imagem
function findItem(product, cod_sku) {
  const items = product.items || [];

  if (cod_sku) {
    const bySku = items.find((item) => item.sku === cod_sku);
    if (bySku) return bySku;
  }
  return items.find((item) => item.image_url) || items[0] || null;
}

async function setProductInfo(product) {
  const item = findItem(product, sku);

  categoryName.textContent = product.category || '';
  productTitle.textContent = product.name || '';
  // A cor só é exibida quando o sku foi informado, já que o produto tem várias
  productColorName.textContent = sku && item ? item.color_name || '' : '';

  setManual(product);

  infoLinks.classList.remove('d-none');
  productInfo.classList.remove('d-none');

  await setMedia(product, item);
}

// O catálogo às vezes traz o código com query colada ("abc?si=...") ou a URL inteira; só o id serve
function youtubeId(code) {
  const match = String(code || '')
    .trim()
    .match(/(?:youtu\.be\/|v[=/]|embed\/)?([A-Za-z0-9_-]{11})(?:[?&#].*)?$/);

  return match ? match[1] : '';
}

// Vídeo privado, removido ou sem permissão de embed responde diferente de 200 no oEmbed.
// Sem essa checagem o player entra na página exibindo "vídeo indisponível" no lugar do produto.
async function videoDisponivel(videoId) {
  const alvo = `https://www.youtube.com/watch?v=${videoId}`;

  try {
    const response = await fetch(`${YOUTUBE_OEMBED}?format=json&url=${encodeURIComponent(alvo)}`);
    return response.ok;
  } catch (error) {
    // rede fora ou bloqueio: melhor cair para a imagem do que arriscar o player quebrado
    return false;
  }
}

// A imagem entra na hora e o vídeo assume o lugar quando a consulta confirma. Como o container
// já reserva o espaço, a troca acontece dentro da mesma caixa e não mexe no resto da página.
async function setMedia(product, item) {
  // campos do catálogo chegam como null com alguma frequência, então nada de concatenar direto
  const title = escapeHtml([product.name, product.brand_name].filter(Boolean).join(' | '));
  const videoId = youtubeId(product.youtube_code);

  if (item && item.image_url) {
    videoContainer.innerHTML = `<div><img src="${escapeHtml(item.image_url)}" class="img-thumbnail" alt="${title}"></div>`;
  } else {
    videoContainer.innerHTML = '';
  }

  if (!videoId || !(await videoDisponivel(videoId))) return;

  videoContainer.innerHTML = `
    <div>
      <iframe
        src="https://www.youtube.com/embed/${videoId}?modestbranding=1&amp;rel=0"
        title="${title}"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen="1"></iframe>
    </div>
  `;
}

// No S3 o espaço no nome do arquivo vira "_", mas o catálogo devolve o nome original.
// O acento permanece no arquivo: basta o encodeURI codificar.
function manualUrl(url) {
  const bruto = String(url || '').trim();
  const corte = bruto.lastIndexOf('/');
  if (!bruto || corte < 0) return bruto;

  return encodeURI(bruto.slice(0, corte + 1) + bruto.slice(corte + 1).replace(/\s/g, '_'));
}

// Manuais: a preferência é o objeto manuals; sem ele, o campo manual; sem os dois, o link não aparece
function setManual(product) {
  const manuals = (product.manuals || []).filter((manual) => manual && manual.url);
  const manualItem = manualLink.closest('li');

  if (manuals.length > 1) {
    manualList.innerHTML = manuals
      .map(
        (manual, index) =>
          `<li><a href="${escapeHtml(manualUrl(manual.url))}" target="_blank" rel="noopener">${escapeHtml(
            manualName(manual, index)
          )}</a></li>`
      )
      .join('');
    manualLink.setAttribute('href', 'javascript:void(0);');
    manualLink.setAttribute('aria-expanded', 'false');
    manualLink.removeAttribute('target');
    manualLink.addEventListener('click', toggleManualList);
    return;
  }

  const url = manualUrl(manuals.length ? manuals[0].url : product.manual);
  if (!url) {
    manualItem.classList.add('d-none');
    return;
  }
  manualLink.setAttribute('href', url);
}

function toggleManualList(e) {
  e.preventDefault();
  const isExpanded = manualLink.getAttribute('aria-expanded') === 'true';
  manualLink.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
  manualList.classList.toggle('d-none', isExpanded);
}

// Nome do arquivo (ex.: "20220825 REV4 Eva STR002 GUIDE.pdf") em um rótulo legível
function manualName(manual, index) {
  const label = String(manual.name || '')
    .replace(/\.pdf$/i, '')
    .split(/[\s_]+/)
    .filter((part) => part && !/^\d{6,8}$/.test(part) && !/^rev\d*$/i.test(part) && !/^guide$/i.test(part))
    .join(' ')
    .trim();

  return label || `Manual ${index + 1}`;
}

// Todos os caminhos para o registro levam o mesmo prd
function setRegistryLink(id) {
  const href = id ? `${REGISTRY_PATH}?prd=${encodeURIComponent(id)}` : REGISTRY_PATH;
  registryLinks.forEach((link) => {
    link.href = href;
  });
}

function escapeHtml(value) {
  return String(value == null ? '' : value).replace(
    /[&<>"']/g,
    (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]
  );
}

inicializar(API_URL);
